
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/quality-control",
      function () {
        return require("private-next-pages/about-us/quality-control.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/quality-control"])
      });
    }
  